import { render, staticRenderFns } from "./CustomerCrmSnapshotSummaryReport.vue?vue&type=template&id=20b161f7&"
import script from "./CustomerCrmSnapshotSummaryReport.vue?vue&type=script&lang=js&"
export * from "./CustomerCrmSnapshotSummaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports